const IntegratedSearchEngine = (function () {

    const memoryParam = {
        query : '',
        pageIndex : 0,
        listCount : 10, // 기본 페이지당 데이터 개수 설정
        sort : 'SCORE/DESC',
        collection : 'ALL',
        reQuery : 'N', // 결과내 재검색
        // realQuery : '', // 재검색을 위한 이전 검색 키워드 (reQuery 가 'Y' 인 경우)
        typeValue : '', // 카테고리 검색시 | 로 값 나눠서 전달
    }

    const API_URL = '/en/search/search';

    async function search(param={}, isEnter=false){
        // 파라미터 최신화
        Object.assign(memoryParam, param);

        const requestParam = structuredClone(memoryParam);
        if(memoryParam.reQuery === 'Y'){
          if(isEnter){
            requestParam['realQuery'] = localStorage.getItem("realQuery");
          }else{
            requestParam['realQuery'] = getRealQuery();
          }
        }

        const response = await fetch(API_URL, {
            method : "POST",
            headers : {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestParam)
        })
        if(!response.ok){
            throw new Error('검색엔진 조회중 오류 발생');
        }

        return await response.json();
    }

    // 페이지 노출은 1부터, api 는 0부터 여서 -1 처리후 호출
    async function searchWithPageNum(pageNum){
        if(pageNum >= 1){
            pageNum = pageNum - 1;
        }
        const param = {
            pageIndex : pageNum
        }

        return await search(param);
    }

    function setParam(param={}){
        // 파라미터 최신화
        Object.assign(memoryParam, param);
    }

    // 카테고리 검색시 사용하는 typeValue 값 갱신 처리
    function storeCategoryValue(value){
        let tmpTypeValue = (memoryParam.typeValue + '|' + value).replace(/^\|+|\|+$/g, '');

        if(value == 'ALL'){
            tmpTypeValue = '';
        }

        // 저장되어 있는 값 가져와서 | 로 추가
        const param = {
            typeValue : tmpTypeValue
        }

        setParam(param);
    }
    function removeCategoryValue(value){
        let tmpTypeValue = memoryParam.typeValue.replace(value, '').replace(/^\|+|\|+$/g, '');

        if(value == 'ALL'){
            tmpTypeValue = '';
        }

        // 현재 지우려는 카테고리 값 공백치환, 맨 앞, 맨 뒤 | 제거
        const param = {
            typeValue : tmpTypeValue
        }
        setParam(param);
    }

    function storeRealQuery(query){
      const stored = localStorage.getItem("realQueryQueue");
      let queue = stored ? JSON.parse(stored) : [];

      queue.push(query);

      if(queue.length > 2){ // 2개 초과시 예전에 넣은거 제거
        queue.shift();
      }

      localStorage.setItem("realQueryQueue", JSON.stringify(queue)); // 탭변경, 카테고리 변경 등에서 사용
      localStorage.setItem("realQuery", query); // 엔터로 검색시 사용
    }
    function getRealQuery(){
      const stored = localStorage.getItem("realQueryQueue");
      const queue = stored ? JSON.parse(stored) : [];
      return queue.length > 0 ? queue[0] : '';
    }

    // 페이징에 사용할 파라미터
    function getPageRow(){
        return memoryParam.listCount;
    }
    function getPageNum(){
        return memoryParam.pageIndex + 1;
    }
    function getPageCnt(){
        return 5;
    }

	return {
	    search,
	    searchWithPageNum,
	    setParam,
	    storeCategoryValue,
	    removeCategoryValue,
	    storeRealQuery,
	    getPageRow,
	    getPageNum,
	    getPageCnt
	}

})();
